import React, { Component } from "react";
import { Text } from "../styles/form-step-styles";
import trackEvent from "../../shared/ga/trackEvent";

class Step3 extends Component {
  componentDidMount() {
    trackEvent("Form Fill", "Post A Job", "Partial");
  }

  render() {
    return (
      <Text className="animated fadeInLeft delay-2">
        Please check your inbox to verify your email address.
      </Text>
    );
  }
}

export default Step3;
